import moment from 'moment'

export function getAge(timestamp) {
  return Math.floor((Date.now() - +moment(timestamp)) / 31536000000) //1y
}

export function normalizeEvent({ time_start, time_finish, ...data }) {
  return {
    time_start: time_start * 1000,
    time_finish: time_finish * 1000,
    ...data,
  }
}

export const isToday = (date) => moment().diff(date, 'days') === 0

export const timeToTimeStamp = (time) => {
  const djsTime = moment(getTimestamp(time))
  let mask = 'DD MMM, HH:mm'

  if (isToday(djsTime)) {
    mask = 'HH:mm'
  } else if (moment().year() !== djsTime.year()) {
    mask = 'DD MMM YYYY, HH:mm'
  }

  return djsTime.format(mask)
}

export const timeToDate = (time) => {
  const djsTime = moment(getTimestamp(time))
  let mask = 'MMMM DD, YYYY'

  return djsTime.format(mask)
}

export const timeToHHMM = (time) => {
  return moment(getTimestamp(time)).format('HH:mm')
}
export const getTimestamp = (time) => {
  return time < 9999999999 ? time * 1000 : time
}
